import {
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  useMutation as useApolloMutation,
} from '@apollo/client';
import { DocumentNode } from 'apollo-link/lib/types';
import { useEffect } from 'react';

import { useToasts } from '@sbu/contexts.toasts';

import { checkError } from 'shared/components/utils/graphql/GraphqlErrorHandler';

type MutationOptions = {
  notifyErrors?: boolean;
};

export function useMutation<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables> & MutationOptions
): MutationTuple<TData, TVariables> {
  const { addError } = useToasts();
  const [mutate, meta] = useApolloMutation<TData, TVariables>(mutation, {
    errorPolicy: 'all',
    ...(options || {}),
  });
  const loading = meta.loading;
  const error = meta.error;
  const notifyErrors = options?.notifyErrors;

  useEffect(() => {
    if (!loading && error && notifyErrors !== false) {
      addError(checkError(error));
    }
  }, [loading, error, notifyErrors, addError]);

  return [mutate, meta] as MutationTuple<TData, TVariables>;
}
